<template>
  <v-autocomplete
    :items="shopList"
    v-model="shopIds"
    label="Select Shop"
    :item-text="(s) => s.name + '/' + s.code"
    item-value="id"
    :loading="shopLoading"
    hide-no-data
    multiple
  ></v-autocomplete>
</template>
<script>
import { shopService } from "../../services/shop-service";
import { commonService } from "../../services/common-service";

export default {
  name: "ShopMultiSelect",

  props: ["ids"],

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    shopList: [],
    shopLoading: false,
  }),

  computed: {
    shopIds: {
      get() {
        return this.ids;
      },
      set(idList) {
        this.setShops(idList);
      },
    },
  },
  created() {
    if (this.user.branchId) {
      this.getShopByBranch(this.user.branchId);
    } else {
      this.getShopList();
    }
  },

  methods: {
    getShopList() {
      this.shopLoading = true;
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.shopLoading = false;
        });
    },
    getShopByBranch(id) {
      this.shopLoading = true;
      shopService
        .getShopByBranch(id)
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.shopLoading = false;
        });
    },
    setShops(shopIdList) {
      let selectedShops = shopIdList.map((shopId) => {
        let shop = commonService.search("id", shopId, this.shopList);
        let obj = {
          id: shop.id,
          name: shop.name,
          code: shop.code,
        };
        return obj;
      });
      this.$emit("set", selectedShops);
    },
  },
};
</script>
